import { render, staticRenderFns } from "./municipality-messages.vue?vue&type=template&id=69a56eda&"
import script from "./municipality-messages.vue?vue&type=script&lang=js&"
export * from "./municipality-messages.vue?vue&type=script&lang=js&"
import style0 from "./municipality-messages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports